import React from 'react';

import EntryWrap from './styled/EntryWrap';
import Month from './styled/Month';

const Entry: React.FC<{
  first?: boolean;
  last?: boolean;
  month?: string;
  text: string;
}> = ({ first, last, month, text }) => (
  <EntryWrap>
    {month !== undefined && (
      <Month first={first} last={last}>
        {month}
      </Month>
    )}
    {text}
  </EntryWrap>
);

export default Entry;
